module.exports = __webpack_public_path__ + "img/training-icon.3e9ce508.svg";